{
  "actionbar.actions": "Ações",
  "actionbar.actionsAvailable": "Ações disponíveis.",
  "actionbar.clearSelection": "Limpar seleção",
  "actionbar.selected": "{count, plural, =0 {Nenhum selecionado} one {# selecionado} other {# selecionados}}",
  "actionbar.selectedAll": "Todos selecionados",
  "breadcrumbs.more": "Mais itens",
  "button.pending": "pendente",
  "calendar.invalidSelection": "{selectedCount, plural, one {Data} other {Datas}} selecionada(s) indisponível(is).",
  "combobox.noResults": "Nenhum resultado",
  "contextualhelp.help": "Ajuda",
  "contextualhelp.info": "Informações",
  "datepicker.endTime": "Hora final",
  "datepicker.startTime": "Hora inicial",
  "datepicker.time": "Hora",
  "dialog.alert": "Alerta",
  "dialog.dismiss": "Descartar",
  "dropzone.replaceMessage": "Solte o arquivo para substituir",
  "inlinealert.informative": "Informações",
  "inlinealert.negative": "Erro",
  "inlinealert.notice": "Aviso",
  "inlinealert.positive": "Sucesso",
  "label.(optional)": "(opcional)",
  "label.(required)": "(obrigatório)",
  "menu.moreActions": "Mais ações",
  "notificationbadge.indicatorOnly": "Nova atividade",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Selecionar…",
  "picker.selectedCount": "{count, plural, =0 {Nenhum item selecionado} one {# item selecionado} other {# itens selecionados}}",
  "slider.maximum": "Máximo",
  "slider.minimum": "Mínimo",
  "table.cancel": "Cancelar",
  "table.editCell": "Editar célula",
  "table.loading": "Carregando...",
  "table.loadingMore": "Carregando mais...",
  "table.resizeColumn": "Redimensionar coluna",
  "table.save": "Salvar",
  "table.sortAscending": "Ordenar por ordem crescente",
  "table.sortDescending": "Ordenar por ordem decrescente",
  "tag.actions": "Ações",
  "tag.hideButtonLabel": "Mostrar menos",
  "tag.noTags": "Nenhum",
  "tag.showAllButtonLabel": "Mostrar tudo ({tagCount, number})",
  "toast.clearAll": "Limpar tudo",
  "toast.collapse": "Recolher",
  "toast.showAll": "Mostrar tudo"
}
